import PropTypes from "prop-types";
import { useFormState } from "react-hook-form";
const ApexFields = ({
  children
}) => {
  const formStateProxy = useFormState();
  const formState = {
    isSubmitSuccessful: formStateProxy.isSubmitSuccessful
  };
  return !formState.isSubmitSuccessful && children;
};
ApexFields.propTypes = {
  children: PropTypes.node.isRequired
};
ApexFields.defaultProps = {};
export {
  ApexFields as default
};
